import React from 'react';
import {
  Button,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const MultiFileUpload = ({ onFilesSelect, selectedFiles = [], id = 'multi-file-upload' }) => {
  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);
    if (newFiles.length > 0) {
      // Append new files to existing ones
      onFilesSelect([...selectedFiles, ...newFiles]);
    }
    // Reset input value to allow selecting the same file again
    event.target.value = '';
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    onFilesSelect(updatedFiles);
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <Box>
      <input
        accept="*"
        style={{ display: 'none' }}
        id={id}
        type="file"
        multiple
        onChange={handleFileChange}
      />
      <label htmlFor={id}>
        <Button
          variant="outlined"
          component="span"
          startIcon={<UploadFileIcon />}
          fullWidth
        >
          Choose Files
        </Button>
      </label>

      {selectedFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Selected {selectedFiles.length} file(s):
          </Typography>
          <List dense>
            {selectedFiles.map((file, index) => (
              <ListItem
                key={index}
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: 1,
                  mb: 1,
                  backgroundColor: '#f5f9ff',
                }}
              >
                <AttachFileIcon color="primary" sx={{ mr: 1 }} />
                <ListItemText
                  primary={file.name}
                  secondary={formatFileSize(file.size)}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => handleRemoveFile(index)}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default MultiFileUpload;
